import React from "react"
import PropTypes from "prop-types"
import { UncontrolledTooltip } from "reactstrap"
import { scaleLinear } from "d3-scale"
import momentPropTypes from "react-moment-proptypes"
import { TimelineContext } from "./"
import moment from "moment"

export default class Event extends React.PureComponent {
  static contextType = TimelineContext

  constructor(props) {
    super(props)
    this.tooltipRef = React.createRef()
    this.state = {
      readyForHover: false,
    }
  }

  componentDidMount() {
    this.setState({ readyForHover: true })
  }

  render() {
    // Events are positioned absolutely from the left of the timeline. If we know our event is halfway through the
    // timeline's time range, we would position it with "left: 50%". In order to derive this percentage for an arbitrary
    // time within the range, we use scaleLinear() to produce a mapping of our overall time range (domain) to a mapping
    // of 0-100% (range).
    const eventStartPct = scaleLinear()
      .domain([this.context.startAt.unix(), this.context.endAt.unix()])
      .range([0, 100])(this.props.startAt.unix())

    const timelineRange =
      this.context.endAt.unix() - this.context.startAt.unix()
    const eventRange = this.props.endAt.unix() - this.props.startAt.unix()
    const eventWidthPct = (eventRange / timelineRange) * 100
    const roundWidthPx = (eventRange / timelineRange) * 1000 + 20

    return (
      <div
        className={`Event ${this.props.className ? this.props.className : ""}`}
        style={{
          left: `${eventStartPct}%`,
          width: `${eventWidthPct}%`,
        }}
        ref={this.tooltipRef}
      >
        {this.state.readyForHover && this.props.tooltipContent && (
          <UncontrolledTooltip
            boundariesElement="window"
            placement="top"
            container={this.tooltipRef.current}
            target={this.tooltipRef.current}
            autohide={false}
            // isOpen={true} // Uncomment for easier styling.
            {...this.props.tooltipOptions}
          >
            {this.props.tooltipContent}
          </UncontrolledTooltip>
        )}
        {this.props.children}
        {this.props.className === "hourlySummary good" && (
          <RoundingBadge
            nurseInfo={this.props.nurseInfo || {}}
            badgeWidth={roundWidthPx}
          />
        )}
        {this.props.className === "hourlySummary bad" && (
          <span className="bad" />
        )}
        {this.props.className === "hourlySummary empty" && (
          <span className="empty" />
        )}
      </div>
    )
  }
}

class RoundingBadge extends React.Component {
  render() {
    if (Object.keys(this.props.nurseInfo).length === 0) return null
    if (Object.values(this.props.nurseInfo).some(v => v === null)) return null

    const splitUsername = this.props.nurseInfo.userName.split(" ")
    const formattedUsername =
      splitUsername[0].charAt(0) +
      ". " +
      splitUsername[splitUsername.length - 1]

    const formattedVisitDuration = moment(
      this.props.nurseInfo.visitDuration * 1000
    ).format("mm:ss")
    const formattedEntry = moment
      .parseZone(this.props.nurseInfo.entry)
      .format("hh:mm:ss A")

    return (
      <div
        className={`RoundingBadge ${
          this.props.badgeWidth < 105 ? "day" : "night"
        }`}
        style={{
          width: this.props.badgeWidth,
        }}
      >
        <p className="text-extrasmall semi-bold NurseName">
          {formattedUsername}
        </p>
        <p className="text-extrasmall">{formattedEntry}</p>
        <p className="text-extrasmall">({formattedVisitDuration})</p>
      </div>
    )
  }
}

Event.propTypes = {
  startAt: momentPropTypes.momentObj.isRequired,
  endAt: momentPropTypes.momentObj.isRequired,
  tooltipContent: PropTypes.node,
  tooltipOptions: PropTypes.object,
  className: PropTypes.string,
  nurseInfo: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.node,
  ]),
}

RoundingBadge.propTypes = {
  nurseInfo: PropTypes.object,
  badgeWidth: PropTypes.number,
}
